




































































































































import { storeRefDokter } from "@/store/modules/bridgingVclaim/RefDokter";
import { storeRefPoli } from "@/store/modules/bridgingVclaim/RefPoli";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SPRI from "@/services/bridgingVclaim/SPRI";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";

@Component({
  components: { ModalKonfirmasi },
})
export default class InputSPRI extends Vue {
  noSep: "";
  noKartu: "";
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  tglShowSPRI = false;
  tglSPRI = "";
  poli = "";
  dokter = "";
  cm = "";
  noSpri = "";
  saving = false;
  printing = false;
  deleting = false;
  get listPoli() {
    return storeRefPoli.refPoli;
  }
  get listDokter() {
    return storeRefDokter.refDokter;
  }
  get sep() {
    return storeSEP.sep;
  }
  @Watch("sep")
  cekspri(val) {
    this.noSep = val.noSep;
    this.noKartu = val.noKartu;
    if (val.spri) {
      this.noSpri = val.spri.noSPRI;
      this.cm = val.noMr;
      this.tglSPRI = val.spri.tglRencanaKontrol;
      this.poli = val.spri.poli.kode;
      this.dokter = val.spri.dokter.kode;
    } else {
      this.noSpri = "";
      this.cm = val.noMr;
      this.tglSPRI = "";
      this.poli = "";
      this.dokter = "";
    }
  }
  get dataSPRI() {
    return {
      noSEP: this.noSep,
      noKartu: this.noKartu,
      noMr: this.cm,
      kodeDokter: this.dokter,
      poliKontrol: this.poli,
      tglRencanaKontrol: this.tglSPRI,
      user: "Coba Ws",
    };
  }
  get editSPRI() {
    return {
      noSPRI: this.noSpri,
      noSEP: this.noSep,
      noKartu: this.noKartu,
      noMr: this.cm,
      kodeDokter: this.dokter,
      poliKontrol: this.poli,
      tglRencanaKontrol: this.tglSPRI,
      user: "Coba Ws",
    };
  }
  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }
  simpan() {
    console.log("simpan", this.dataSPRI);
    if (!this.saving) {
      this.saving = true;
      SPRI.create(this.dataSPRI)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            // this.clear();
            console.log("resp", resp);
            appModule.NoticeDelay(
              "Berhasil Membuat SPRI, no SPRI=" + this.noSpri
            );
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
  ubah() {
    console.log("ubah", this.editSPRI);
    if (!this.saving) {
      this.saving = true;
      SPRI.edit(this.editSPRI)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            // this.clear();
            console.log("resp", resp);
            appModule.NoticeDelay("Berhasil Mengubah SPRI");
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
  cetak() {
    if (!this.printing) {
      this.printing = true;
      SPRI.print(this.noSpri);
      this.printing = false;
    }
  }
  konfirmHapus() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm =
      "Anda yakin ingin menghapus SPRI dengan no: " + this.noSpri;
  }
  hapus() {
    const dt = {
      noSPRI: this.noSpri,
      user: "Coba Ws",
    };
    if (!this.deleting) {
      this.deleting = true;
      SPRI.hapus(dt)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            appModule.NoticeDelay("Berhasil Menghapus SPRI");
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
}
